export default {
  title: 'Language',
  dataTitle: 'Language information',
  selectLanguage: 'Choose language',
  th: 'Thai',
  en: 'English'
}
